import BaseModel from '@/orm/models/BaseModel';

export default class HHIntegration extends BaseModel {
  static entity = 'hhIntegration'

  static fields() {
    return {
      id: this.attr(null),
      companyId: this.attr(null),
      employerId: this.attr(null),
      hasCode: this.boolean(false),
      hasToken: this.boolean(false),
      hasRefreshToken: this.boolean(false),
      authNeeded: this.attr(null),
      newAuthNeeded: this.attr(null),
      tokenExpiresAt: this.attr(null),
    };
  }

  static apiConfig = {
    actions: {
      getCodeRedirectUri() {
        return this.get('companies/hh/code-redirect-uri', { save: false });
      },

      getIntegrationData() {
        return this.get('companies/hh/integration-data', {
          save: false,
          dataTransformer: (r) => {
            const data = r.data.data || r.data || {};
            if (data && typeof data === 'object') {
              return data;
            }
            return {};
          },
        });
      },

      getSettings() {
        return this.get('companies/candidate-ai-processor-settings/settings', {
          save: false,
          dataTransformer: (r) => {
            return r.data.data || r.data || {};
          },
        });
      },

      updateSettings(payload) {
        return this.post('companies/candidate-ai-processor-settings/settings', payload, { save: false });
      },

      fetchVacancies() {
        return this.get('companies/hh/vacancies', {
          save: false,
          dataTransformer: (r) => {
            return r.data.data || r.data || [];
          },
        });
      },

      importAllVacancies(payload = {}) {
        return this.post('companies/hh/vacancies/import', payload, { save: false });
      },

      importVacancy(hhVacancyId, payload = {}) {
        return this.post(`companies/hh/vacancies/import/${hhVacancyId}`, payload, {
          save: false,
        });
      },

      removeIntegration() {
        return this.delete('companies/hh/remove-integration', { save: false });
      },

      attachToExisting(vacancyId, hhVacancyId) {
        return this.post(`companies/hh/vacancies/attach-to-existing/${vacancyId}/from/${hhVacancyId}`, {}, { save: false });
      },
    },
  }
}
